import React from 'react'
import { connect } from 'react-redux'
import { getUnitIds, getUnitMap, getSelectedUnits } from '../selectors'
import * as actions from '../actions'
import R from 'ramda'
import { Select } from 'antd'
const toOptions = (unitMap, unitIds) =>
  R.sortWith([R.ascend(R.prop('text'))])(
    unitIds.map(unitId => ({
      key: unitId,
      value: unitId,
      text: unitMap[unitId] || unitId,
    }))
  )

const UnitSelector = ({
  unitMap,
  unitIds,
  selectedUnits,
  // onChange,
  selectUnits,
  fluid = true,
  disabled,
  multiple,
}) => (
  <Select
    placeholder="Select Unit"
    search
    // selection
    // fluid={fluid}
    style={{ width: fluid ? '100%' : '200px' }}
    disabled={disabled}
    mode={multiple ? 'multiple' : 'default'}
    // options={toOptions(unitMap, unitIds)}
    onChange={value => selectUnits(multiple ? value : [value])}
    value={selectedUnits}
  >
    {toOptions(unitMap, unitIds).map(d => (
      <Select.Option key={d.key} value={d.value}>
        {d.text}
      </Select.Option>
    ))}
  </Select>
)

const mapStateToProps = (state, { multiple }) => ({
  unitIds: getUnitIds(state),
  unitMap: getUnitMap(state),
  selectedUnits: multiple
    ? getSelectedUnits(state)
    : getSelectedUnits(state)[0] || '',
})

export { UnitSelector }

export default connect(mapStateToProps, actions)(UnitSelector)
